<template>
  <div class="crumbs-box">
    <div class="crumbs-left">
      <span class="crumbs-title">{{ title }}</span>
      <el-breadcrumb>
        <el-breadcrumb-item v-if="$route.name !== 'Dashboard'" :to="{ name: 'Dashboard' }">{{ $t('routes.dashboard') }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="mainMenu">{{ mainTitle }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="depMenu && depMenu.vueUrl" :to="{ name: depMenu.vueUrl }">{{ depTitle }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <i class="crumbs-refresh iconfont icon-shuaxin" @click="$emit('refresh')" />
  </div>
</template>

<script>
export default {
  computed: {
    menusMap() {
      return this.$store.getters.menusMap
    },
    routesMap() {
      return this.$store.getters.routesMap
    },
    title() {
      const title = this.$route.meta.title
      return this.$te(title) ? this.$t(title) : title
    },
    depMenu() {
      const dep = this.$route.meta.dep
      return dep ? this.routesMap[dep] : null
    },
    depTitle() {
      return this.depMenu && this.depMenu.name
    },
    mainMenu() {
      const menu = this.depMenu || this.routesMap[this.$route.name]
      const mainMenu = this.menusMap[menu && menu.parentId]
      return mainMenu ? this.menusMap[mainMenu.id] : null
    },
    mainTitle() {
      return this.mainMenu && this.mainMenu.name
    }
  }
}
</script>

<style lang="scss" scoped>
.crumbs {
  &-box {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
  }
  &-title {
    font-size: 16px;
    color: #333;
    font-weight: 700;
    padding-right: 15px;
  }
  &-left {
    display: inline-flex;
    align-items: flex-end;
    line-height: 16px;
  }
  &-refresh {
    color: #999999;
    cursor: pointer;
    &:hover {
      color: #666666;
    }
  }
}
</style>
